import React from "react";
import PropTypes from "prop-types";
import Dispatcher from "Dispatcher";
import SearchFormStore from "data/SearchFormStore";
import MergeActions from "data/MergeActions";
import sortsToOrder from "lib/sortsToOrder";
import { GlobalMergeModuleContainer } from "./GlobalMergeContainer";
import SearchResultActions from "data/SearchResultActions";

export class GlobalMergeModule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search: {}
        };

        this.onMerge = this.onMerge.bind(this);
        this.onSearch = this.onSearch.bind(this);
    }

    onSearch() {
        const {fluxContext} = this.props;
        const key = SearchFormStore.getKey(fluxContext);
        const query = SearchFormStore.getQ(fluxContext).toAS();
        const order = sortsToOrder(SearchFormStore.getSorts(fluxContext));
        Dispatcher.dispatch({
            type: SearchResultActions.RESET_SEARCH,
            key,
            query,
            order,
        });
        this.setState({
            search: {
                key,
                query,
                order,
            },
        });
    }

    onMerge() {
        const {
            fluxContext,
        } = this.props;
        Dispatcher.contextDispatch(fluxContext, {
            type: MergeActions.DO_MERGE,
        });
    }

    render() {
        const {
            onCancel,
            fluxContext,
            mergePlugin,
        } = this.props;
        return (
            <GlobalMergeModuleContainer
                mergePlugin={mergePlugin}
                fluxContext={fluxContext}
                onCancel={onCancel}
                onMerge={this.onMerge}
                onSearch={this.onSearch}
                search={this.state.search}
            />
        );
    }
}


export default GlobalMergeModule;


GlobalMergeModule.propTypes = {
    fluxContext: PropTypes.string.isRequired,
    mergePlugin: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/merge/views/global-merge/GlobalMergeModule.js